// 지원하는 Youtube URL 패턴
// www.youtube.com/watch?v={videoId}
// m.youtube.com/watch?v={videoId}
// youtu.be/{videoId}
// youtube.com/shorts/{videoId}
// youtube.com/v/{videoId}
function extractVideoId(
  url: string,
  queryParams: URLSearchParams,
): string | null {
  const videoId =
    queryParams.get('v') ||
    url.match(/youtu\.be\/(.+)/)?.[1] ||
    url.match(/youtube\.com\/(?:v|shorts|embed|live)\/(.+)/)?.[1] ||
    null;
  if (!videoId) return null;
  // 뒤에 쿼리스트링이 나는 경우 에러가 나옵니다
  return videoId.split('?')[0].split('#')[0];
}

export function parseYoutubeUrl(url: string) {
  const queryParams = new URLSearchParams(url.split('?')[1]);
  const videoId = extractVideoId(url, queryParams);

  const autoPlay = ['1', 'true'].includes(queryParams.get('autoplay') ?? '');
  const zepScriptAutoplay = ['1', 'true'].includes(
    queryParams.get('zepScriptAutoplay') ?? '',
  );
  const loop = ['1', 'true'].includes(queryParams.get('loop') ?? '');
  const mute = ['1', 'true'].includes(queryParams.get('muted') ?? '');
  const _t = queryParams.get('t');
  const start = _t != null ? parseInt(_t) : undefined;

  return {
    videoId,
    autoPlay,
    zepScriptAutoplay,
    loop,
    mute,
    start,
  };
}
